import { Component,  OnInit } from '@angular/core';
import { SettingsService } from '../../Services';

@Component({
    selector: 'app-gekocht',
    templateUrl: 'gekocht.component.html',
    styleUrls: ['gekocht.component.css'],
    standalone: false
})

export class GekochtComponent implements OnInit {
    pageSettings: any;
    constructor(public setting: SettingsService) {}
    ngOnInit() {
        let viewType: any;
        if (this.setting.getSetting('show_overview_layout') === 'Foto' ) {
            viewType = 'grid';
        }
        if (this.setting.getSetting('show_overview_layout') === 'Lijst' ) {
            viewType = 'list';
        }

        if (this.setting.getSetting('show_overview_layout') === null || undefined || '') {
            viewType = 'list';
        }

        this.pageSettings = ({
            // View options
            Title: 'Verkocht', // The main title of the page.
            HtmlTitle: 'Expertteam - Verkocht', // The name of the tab in the browser.
            DefaultViewType: viewType, // This can be set to list or grid.
            MaxResultsSettingName: 'valuations_per_page_gekocht',

            AllowBidding: false, // This will enable the option to bid when navigating to detail page
            AllowNavigationOnClick: true, // This will allow the user to navigate to the detail page when row is clicked.

            EnableGridView: true, // The 'gallery' view.
            EnableListView: true, // Default table view.

            EnableOrdering: false,
            EnableFiltering: true, // Enable or disable the filering field, if disabled the default filter will be used.
            EnableSearching: true, // Enable or disable the searching field.
            EnableAmoutOfResults: true,
            EnableItemClicked: true,

            RefreshInterval: 0, // Time in MS when to fetch new data, 0 for disabled.

            // These fields are used to set the search type when searching.
            SearchFields: [{ DisplayName: 'Taxatienummer', RequestFilter: 'currentBidTerm' },
            { DisplayName: 'Biedtermijn', RequestFilter: 'currentBidTerm' },
            { DisplayName: 'Voertuig', RequestFilter: 'currentBidTerm' },
            { DisplayName: 'Kenteken', RequestFilter: 'currentBidTerm' },
            { DisplayName: 'Bouwjaar', RequestFilter: 'currentBidTerm' },
            { DisplayName: 'Carrosserie', RequestFilter: 'currentBidTerm' }],

            // These fields are used to fill the table with some data.
            TableFields: [{ApiField: 'id', DisplayName: 'Taxnr', EnableOrdering: true, orderField: 'id'},
            {ApiField: 'VehicleLicense', DisplayName: 'Kenteken', EnableOrdering: false, orderField: ''},
            {ApiField: 'VehicleMakeType', DisplayName: 'Voertuig', EnableOrdering: true, orderField: 'Vehicle.make'},
            {ApiField: 'VehicleYear', DisplayName: 'Jaar',  EnableOrdering: true, orderField: 'Vehicle.year'},
            {ApiField: 'VehicleDeliveryDate', DisplayName: 'Leverdatum', EnableOrdering: true, orderField: 'dateDelivery'},
            {ApiField: 'BidMyBid', DisplayName: 'Mijn bod', EnableOrdering: false, orderField: ''},
            {ApiField: 'BidHighestBid', DisplayName: 'Hoogste bod', EnableOrdering: false, orderField: ''}],

            // These fields are used to set the filter types.
            FilteringFields: [{ DisplayName: 'Verkocht', RequestFilter: ['purchased'] }],

            // API fields
            DefaultOrdering: 'DESC', // This can be set to ASC and DESC and will affect the view's ordering.
            DefaultFilter: { DisplayName: 'Verkocht', RequestFilter: ['purchased'] },
            DefaultSearchField: { DisplayName: 'Taxatienummer', RequestFilter: 'id' },
            ApiFields: ["id", "VehicleSpecification-Vehicle-make", "VehicleSpecification-Vehicle-modelSpecific",
            "BidList", "VehicleSpecification-Vehicle-registration", "VehicleSpecification-Vehicle-year",
            "VehicleSpecification-BodyType", "VehicleSpecification-FuelType", "VehicleSpecification-mileage", "highestExpertBid",
            "dateDelivery", "VehicleSpecification-type", "ExpertViews", "VehicleSpecification-mileageType"]
        });
    }
}
